import { render, staticRenderFns } from "./ClientsTableContainer.vue?vue&type=template&id=3bed3d20&scoped=true&"
import script from "./ClientsTableContainer.vue?vue&type=script&lang=js&"
export * from "./ClientsTableContainer.vue?vue&type=script&lang=js&"
import style0 from "./ClientsTableContainer.vue?vue&type=style&index=0&id=3bed3d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bed3d20",
  null
  
)

export default component.exports